// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PiggyBankIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM19 8h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2Zm12 6v4a3 3 0 0 1-3 3h-.295l-2.026 5.672A2 2 0 0 1 23.795 28h-1.59a2 2 0 0 1-1.884-1.328l-.24-.672H12.92l-.24.672A2 2 0 0 1 10.795 28h-1.59a2 2 0 0 1-1.884-1.328L5.75 22.277a10.961 10.961 0 0 1-2.68-6.047A2 2 0 0 0 2 18a1 1 0 1 1-2 0 4 4 0 0 1 3.035-3.875A11.015 11.015 0 0 1 14 4h13a1 1 0 1 1 0 2h-2.674a10.992 10.992 0 0 1 3.928 5A3 3 0 0 1 31 14Zm-2 0a1 1 0 0 0-1-1h-.457a1 1 0 0 1-.956-.7A8.988 8.988 0 0 0 18 6h-4a9 9 0 0 0-6.636 15.08 1 1 0 0 1 .205.339L9.205 26h1.59l.478-1.336a1 1 0 0 1 .94-.664h8.573a1 1 0 0 1 .941.664L22.206 26h1.59l2.264-6.336A1 1 0 0 1 27 19h1a1 1 0 0 0 1-1v-4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
